import Img from "../../assets/img/bitrixTooltip/bitrix1.png";
import Img2 from "../../assets/img/bitrixTooltip/bitrix2.png";
import Img3 from "../../assets/img/bitrixTooltip/bitrix3.png";
import Img4 from "../../assets/img/bitrixTooltip/bitrix4.png";
import Img5 from "../../assets/img/bitrixTooltip/bitrix5.png";
import Img6 from "../../assets/img/bitrixTooltip/bitrix6.png";

import styles from "../../ui/Tooltip/Tooltip.module.scss";

export const stepsDataBitrixURL = [
  {
    title: "Скопируйте это значение",
    description: (
      <ul className={styles.ulListContainer}>
        <li>
          Данное значение необходимо будет вставить при настройке "Исходящего
          вебхука"
        </li>
      </ul>
    ),
  },
];

export const stepsDataOutgoing = [
  {
    title: "Перейдите в раздел “Приложения”",
    description: (
      <ul className={styles.ulListContainer}>
        <li>Необходимо совершить вход в Битрикс24.</li>
        <li>Откройте меню слева.</li>
        <li>Найдите пункт “Приложения” и кликните на него.</li>
        <li>
          В открывшемся списке найдите пункт "Разработчикам" и кликните на него.
        </li>
      </ul>
    ),
    imgSrc: Img,
  },
  {
    title: "Выберите категорию “Другое”",
    description: (
      <ul className={styles.ulListContainer}>
        <li>На странице “Разработчикам” найдите раздел “Другое”.</li>
        <li>Кликните на этот раздел, чтобы перейти к настройке вебхуков.</li>
      </ul>
    ),
    imgSrc: Img2,
  },
  {
    title: "Создайте исходящий вебхук",
    description: (
      <ul className={styles.ulListContainer}>
        <li>В разделе “Другое” выберите “Исходящий вебхук”.</li>
        <li>
          Следуйте дальнейшим инструкциям, укажите необходимые параметры и
          сохраните изменения.
        </li>
      </ul>
    ),
    imgSrc: Img3,
  },
  {
    title: "Настройте “Исходящий вебхук”",
    description: (
      <ul className={styles.ulListContainer}>
        <li>
          На открывшейся странице вставьте скопированный "URL вашего
          обработчика".
        </li>
        <li>
          Скопируйте "Токен приложения" и вставьте его в форму, в необходимое
          поле.
        </li>
        <li>Выберите указанные на скриншоте события в поле "События".</li>
      </ul>
    ),
    imgSrc: Img4,
  },
];

export const stepsDataIncoming = [
  {
    title: "Перейдите в раздел “Приложения”",
    description: (
      <ul className={styles.ulListContainer}>
        <li>Необходимо совершить вход в Битрикс24.</li>
        <li>Откройте меню слева.</li>
        <li>Найдите пункт “Приложения” и кликните на него.</li>
        <li>
          В открывшемся списке найдите пункт "Разработчикам" и кликните на него.
        </li>
      </ul>
    ),
    imgSrc: Img,
  },
  {
    title: "Выберите категорию “Другое”",
    description: (
      <ul className={styles.ulListContainer}>
        <li>На странице “Разработчикам” найдите раздел “Другое”.</li>
        <li>Кликните на этот раздел, чтобы перейти к настройке вебхуков.</li>
      </ul>
    ),
    imgSrc: Img2,
  },
  {
    title: "Создайте входящий вебхук",
    description: (
      <ul className={styles.ulListContainer}>
        <li>В разделе “Другое” выберите Входящий вебхук”.</li>
        <li>
          Следуйте дальнейшим инструкциям, укажите необходимые параметры и
          сохраните изменения.
        </li>
      </ul>
    ),
    imgSrc: Img3,
  },
  {
    title: "Скопируйте и настройте необходимые данные",
    description: (
      <ul className={styles.ulListContainer}>
        <li>
          На открывшейся странице скопируйте “Вебхук для вызова rest api”.
        </li>
        <li>
          Вставьте скопированный “Вебхук для вызова rest api” в соответствующее
          поле.
        </li>
      </ul>
    ),
    imgSrc: Img5,
  },
  {
    title: "Предоставьте права",
    description: (
      <ul className={styles.ulListContainer}>
        <li>Необходимо предоставить права, как показаны на скриншоте.</li>
        <li>Нажмите кнопку «Сохранить»</li>
      </ul>
    ),
    imgSrc: Img6,
  },
];
